
// zindex counter
let z = 1000

module.exports = function zindex() {
    return z++
}
